import React, { useState } from "react";
import { JhButton } from "designPackages/buttonPackage";
import useJobPostingPayloadStore from "../../zustandStores/jobPostingPayloadStore";
import { useDispatch, useSelector } from "react-redux";
import {
  editProfile,
  postJob
} from "../../containers/JobPosting/jobPostingActions";
import { deleteLocalStorage, pageAfterJobPosting } from "../../services/utils";
import LogService from "../../services/LogService";
import { JOB_POST_SUCCESS_NEW_USER } from "../../services/webengage/webEngageConstants";

type RenderView = (
  onClick: (event: React.MouseEvent<HTMLElement>) => void
) => JSX.Element;

type JobPlan = "PREMIUM" | "BASIC";

interface PostJobViewProps {
  children?: React.ReactNode;
  renderView?: RenderView;
  jobPlan: JobPlan;
  errorCallback?: (errorObj: any) => void;
  successCallback?: (response: object) => void;
  classes?: string;
}

const PostJobView = ({
  renderView,
  children,
  jobPlan,
  errorCallback,
  successCallback,
  classes
}: PostJobViewProps) => {
  const [loading, setLoading] = useState(false);

  const { payload, reset } = useJobPostingPayloadStore(state => ({
    payload: state.payload,
    reset: state.reset
  }));
  const dispatch = useDispatch();
  const userProfile =
    useSelector((state: any) => state.userProfileReducer.payload?.data) || {};

  const onJobPost = async (e: React.MouseEvent<HTMLElement>) => {
    setLoading(true);
    const { profileData = {}, jobPostingData = {} } = payload || {};
    const { jobDetails = {} } = jobPostingData;
    const { isWhatsAppEnabled, whatsappPhone } = profileData || {};
    const { is_soft_profile_completed: softProfileCompleted } = userProfile;
    dispatch(
      editProfile(
        {
          is_whatsapp_enabled: isWhatsAppEnabled,
          whatsapp_contact: whatsappPhone,
          is_soft_profile_completed: !softProfileCompleted ? true : undefined
        },
        null,
        false
      )
    );
    const jobPostPayload = {
      ...jobPostingData,
      jobDetails: {
        ...jobDetails,
        jobPlan
      }
    };

    try {
      const response = await dispatch(postJob({ ...jobPostPayload }));

      if (!softProfileCompleted) {
        LogService.log(JOB_POST_SUCCESS_NEW_USER);
      }
      deleteLocalStorage();
      reset();
      useJobPostingPayloadStore.persist.clearStorage();
      pageAfterJobPosting(userProfile, response);

      if (successCallback) successCallback(response);
    } catch (error) {
      if (errorCallback) errorCallback(error);
    } finally {
      setLoading(false);
    }
  };

  if (renderView) {
    return renderView(onJobPost);
  }

  return (
    <JhButton className={classes} onClick={onJobPost} disabled={loading}>
      {children}
    </JhButton>
  );
};

export default PostJobView;
